module.exports = __webpack_public_path__ + "static/assets/02afe56a9423c43623701b70d2d7a3ec.svg";